module.exports = __webpack_public_path__ + "static/media/ic-regulation-update.21519095.svg";